import { makeStyles } from '../../../styles';
export const useWizardRequiredSectionStyles = makeStyles((theme) => ({
    headline: {
        fontFamily: theme.typography.fontFamily,
        textTransform: 'uppercase',
        fontSize: '10px',
        fontWeight: theme.typography.fontWeightBold,
        letterSpacing: '0.4px',
        color: theme.colors.gray[500],
        display: 'inline-block',
        margin: '0px 0px 5px 50px',
    },
}));
//# sourceMappingURL=WizardRequiredSection.styles.js.map